import styled from "styled-components";
import { Box } from "@similarweb/ui-components";
import { TopPlayersWidgetTitle } from "./TopPlayersWidgetTitle";
import { TopPlayersWidgetChartLoader } from "./TopPlayersWidgetChartLoader";
import { TopPlayersWidgetCallToAction } from "./TopPlayersWidgetCallToAction";

const TopPlayersWidgetWrapper = styled(Box)`
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
`;

export const TopPlayers = () => {
    return (
        <TopPlayersWidgetWrapper>
            <TopPlayersWidgetTitle />
            <TopPlayersWidgetChartLoader />
            <TopPlayersWidgetCallToAction />
        </TopPlayersWidgetWrapper>
    );
};
